import React from "react";

function MapsLisComponent(props) {
  return (
    <div className="content-line">
      <div className="line line-100">
        <table className="table-results">
          <tbody>
            <tr>
              <th className="table-column-name">Nombre</th>
              <th className="table-column-extension">Extension</th>
              <th className="table-column-size">Tamaño</th>
              <th className="table-column-modifiedDate">
                fecha de última modificacón
              </th>
              {/* <th className="table-column-depen">Dependencia</th>
              <th className="table-column-actions">Acciones</th> */}
            </tr>
            {props.content.map((item, index) => (
              <tr key={"row-table-hg ash-" + index}>
                <td className="table-column-name">{item.name}</td>
                <td className="table-column-extension">{item.type}</td>
                <td className="table-column-size">{item.size}</td>
                <td className="table-column-modifiedDate">
                  {item.lastModified}
                </td>
                {/* <td className="table-column-depen">{item.dependencia}</td>
                <td className="table-column-actions">
                  <div
                    className="table-buttom gray-background-color"
                    onClick={() => props.update(item)}
                  >
                    <Update
                      style={{ color: "white" }}
                      titleAccess="Actualizar"
                    />
                  </div>
                  <div
                    className="table-buttom primary-background-color"
                    onClick={() => props.changePassword(item)}
                  >
                    <Secure
                      style={{ color: "white" }}
                      titleAccess="Cambiar clave"
                    />
                  </div>
                  {!!item.active ? (
                    <div
                      className="table-buttom secondary-background-color"
                      onClick={() => props.activate(item)} 
                    >
                      {" "}
                      <Power
                        style={{ color: "white" }}
                        titleAccess="Desactivar"
                      />
                    </div>
                  ) : (
                    <div
                      className="table-buttom gray-background-color"
                      onClick={() => props.activate(item)}
                    >
                      {" "}
                      <PowerOff
                        style={{ color: "black" }}
                        titleAccess="Activar"
                      />
                    </div>
                  )}
                  
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default MapsLisComponent;
